// THIS FILE IS AUTO-GENERATED by scripts/extractRoutes — do not edit by hand.
// Regenerate with: pnpm generate:routes

export type NavigationRoute = {
  pattern: string;
  label: string;
  availability: string[];
  availabilityExpression?: string;
};

export const NAVIGATION_ROUTES: readonly NavigationRoute[] = [
  {
    pattern: "/assistant/:chatId?",
    label: "assistant page",
    availability: [],
  },
  {
    pattern: "/audit-trail",
    label: "audit trail",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/audit-trail/config",
    label: "audit trail config",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/blueprint/:blueprintId",
    label: "blueprint",
    availability: [],
  },
  {
    pattern: "/blueprint/:blueprintId/create",
    label: "blueprint create stack modal",
    availability: [],
  },
  {
    pattern: "/blueprint/:blueprintId/integrations",
    label: "blueprint integrations",
    availability: [],
  },
  {
    pattern: "/blueprints",
    label: "blueprints",
    availability: [],
  },
  {
    pattern: "/cloud-integrations",
    label: "cloud integrations",
    availability: [],
  },
  {
    pattern: "/context/:contextId",
    label: "context",
    availability: [],
  },
  {
    pattern: "/context/:contextId/files",
    label: "context mounted files",
    availability: [],
  },
  {
    pattern: "/context/:contextId/hooks",
    label: "context hooks",
    availability: [],
  },
  {
    pattern: "/context/:contextId/used-by",
    label: "context used by",
    availability: [],
  },
  {
    pattern: "/contexts",
    label: "contexts",
    availability: [],
  },
  {
    pattern: "/dashboard",
    label: "dashboard",
    availability: [],
  },
  {
    pattern: "/flows",
    label: "flows",
    availability: ["isFlowsAacIntegrationEnabled"],
    availabilityExpression: "isFlowsAacIntegrationEnabled",
  },
  {
    pattern: "/flows/:projectId",
    label: "flows project details",
    availability: ["isFlowsAacIntegrationEnabled"],
    availabilityExpression: "isFlowsAacIntegrationEnabled",
  },
  {
    pattern: "/flows/link/select",
    label: "flows link organizations",
    availability: [],
  },
  {
    pattern: "/flows/login",
    label: "flows login",
    availability: [],
  },
  {
    pattern: "/gpg-keys",
    label: "gpg keys",
    availability: [],
  },
  {
    pattern: "/integrations",
    label: "integrations",
    availability: [],
  },
  {
    pattern: "/integrations/:integrationGroup",
    label: "integrations group",
    availability: [],
  },
  {
    pattern: "/integrations/:integrationGroup/:integrationId",
    label: "integrations",
    availability: [],
  },
  {
    pattern: "/intent-project/:intentProjectId",
    label: "intent project",
    availability: [],
  },
  {
    pattern: "/intent-project/:intentProjectId/environment",
    label: "intent project environment",
    availability: [],
  },
  {
    pattern: "/intent-project/:intentProjectId/history",
    label: "intent project history",
    availability: [],
  },
  {
    pattern: "/intent-project/:intentProjectId/integrations",
    label: "intent project integrations",
    availability: [],
  },
  {
    pattern: "/intent-project/:intentProjectId/policies",
    label: "intent project policies",
    availability: [],
  },
  {
    pattern: "/intent-projects",
    label: "intent projects",
    availability: [],
  },
  {
    pattern: "/launchpad",
    label: "launchpad",
    availability: [],
  },
  {
    pattern: "/launchpad/learn/:userGuideGroupId",
    label: "learn",
    availability: [],
  },
  {
    pattern: "/launchpad/track",
    label: "launch pad track",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/login-policy/:policyId",
    label: "login policy",
    availability: [],
  },
  {
    pattern: "/login-policy/:policyId/samples",
    label: "login policy details samples",
    availability: [],
  },
  {
    pattern: "/mission-control",
    label: "mission control",
    availability: [],
  },
  {
    pattern: "/module/:moduleId",
    label: "module",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/contexts",
    label: "module contexts",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/environment",
    label: "environment",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/notifications",
    label: "module notifications",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/policies",
    label: "module policies",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/prs",
    label: "module pull requests",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/run/:runId",
    label: "run",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings",
    label: "settings",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/availability",
    label: "module settings availability",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/behavior",
    label: "module settings behavior",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/deletion",
    label: "module settings deletion",
    availability: ["canManageModule.result"],
    availabilityExpression: "canManageModule.result",
  },
  {
    pattern: "/module/:moduleId/settings/integrations",
    label: "integrations",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/integrations/cloud",
    label: "cloud integrations",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/integrations/webhook/:webhookId",
    label: "module settings integrations webhook",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/integrations/webhook/:webhookId/delivery/:deliveryId",
    label: "delivery",
    availability: [],
  },
  {
    pattern:
      "/module/:moduleId/settings/integrations/webhook/:webhookId/delivery/:deliveryId/request",
    label: "webhook details response",
    availability: [],
  },
  {
    pattern:
      "/module/:moduleId/settings/integrations/webhook/:webhookId/delivery/:deliveryId/response",
    label: "webhook details response",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/integrations/webhooks",
    label: "webhooks",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/sharing",
    label: "module settings sharing new",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/settings/source-code",
    label: "module settings source code",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId",
    label: "version",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/changelog",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/consumers",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/dependencies",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/example/:exampleId",
    label: "example",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/example/:exampleId/inputs",
    label: "module version inputs",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/example/:exampleId/outputs",
    label: "module version outputs",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/examples",
    label: "module version examples",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/inputs",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/outputs",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/overview",
    label: "overview",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/overview/changelog",
    label: "module version changelog",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/overview/consumers",
    label: "module version consumers",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/overview/dependencies",
    label: "module version dependencies",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/overview/inputs",
    label: "module version inputs",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/overview/outputs",
    label: "module version outputs",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/overview/resources",
    label: "module version resources",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/overview/tests",
    label: "module version test cases",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/resources",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/run/:runId",
    label: "run",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/runs",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/submodule/:submoduleId",
    label: "submodule",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/submodule/:submoduleId/dependencies",
    label: "module version dependencies",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/submodule/:submoduleId/inputs",
    label: "module version inputs",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/submodule/:submoduleId/outputs",
    label: "module version outputs",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/submodule/:submoduleId/resources",
    label: "module version resources",
    availability: [],
  },
  {
    pattern: "/module/:moduleId/version/:versionId/submodules",
    label: "module version submodules",
    availability: [],
  },
  {
    pattern: "/modules",
    label: "modules new",
    availability: [],
  },
  {
    pattern: "/new/context",
    label: "new context",
    availability: [],
  },
  {
    pattern: "/new/login-policy",
    label: "login policy create",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/new/module",
    label: "new module",
    availability: [],
  },
  {
    pattern: "/new/policy",
    label: "new policy",
    availability: [],
  },
  {
    pattern: "/new/scan",
    label: "schedule scan wizard",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/new/stack",
    label: "new stack",
    availability: [],
  },
  {
    pattern: "/new/webhook",
    label: "new webhook",
    availability: [],
  },
  {
    pattern: "/notifications",
    label: "notifications",
    availability: [],
  },
  {
    pattern: "/opentofu-migration",
    label: "opentofu migration",
    availability: ["opentofuBackend"],
    availabilityExpression: "opentofuBackend",
  },
  {
    pattern: "/opentofu-migration/queue",
    label: "open tofu migration queue",
    availability: ["opentofuBackend"],
    availabilityExpression: "opentofuBackend",
  },
  {
    pattern: "/personal-settings",
    label: "personal settings",
    availability: [],
  },
  {
    pattern: "/personal-settings/accessibility",
    label: "accessibility settings",
    availability: [],
  },
  {
    pattern: "/personal-settings/api-keys",
    label: "personal settings api keys",
    availability: ["personalApiKeys"],
    availabilityExpression: "personalApiKeys",
  },
  {
    pattern: "/personal-settings/datetime-settings",
    label: "date time settings",
    availability: [],
  },
  {
    pattern: "/personal-settings/external-accounts",
    label: "external accounts",
    availability: ["canSeeExternalAccounts"],
    availabilityExpression: "canSeeExternalAccounts",
  },
  {
    pattern: "/personal-settings/groups",
    label: "personal settings groups",
    availability: [],
  },
  {
    pattern: "/personal-settings/mfa",
    label: "mfa settings",
    availability: [],
  },
  {
    pattern: "/personal-settings/notifications-customization",
    label: "notifications customization",
    availability: [],
  },
  {
    pattern: "/personal-settings/sidebar-customization",
    label: "customize sidebar",
    availability: [],
  },
  {
    pattern: "/personal-settings/spaces",
    label: "personal settings spaces",
    availability: [],
  },
  {
    pattern: "/personal-settings/theme-appearance",
    label: "theme appearance",
    availability: [],
  },
  {
    pattern: "/plugin-templates",
    label: "plugin templates",
    availability: [],
  },
  {
    pattern: "/plugins",
    label: "plugins",
    availability: [],
  },
  {
    pattern: "/policies",
    label: "policies",
    availability: [],
  },
  {
    pattern: "/policies-templates",
    label: "policies templates",
    availability: [],
  },
  {
    pattern: "/policy/:policyId",
    label: "policy",
    availability: [],
  },
  {
    pattern: "/policy/:policyId/samples",
    label: "policy details samples",
    availability: ["canManagePolicy.result"],
    availabilityExpression: "canManagePolicy.result",
  },
  {
    pattern: "/policy/:policyId/used-by",
    label: "policy details used by",
    availability: [
      "data.policy.type !== PolicyType.Notification && data.policy.type !== PolicyType.Intent",
    ],
    availabilityExpression:
      "data.policy.type !== PolicyType.Notification && data.policy.type !== PolicyType.Intent",
  },
  {
    pattern: "/provider/:providerId",
    label: "provider",
    availability: [],
  },
  {
    pattern: "/provider/:providerId/version/:versionNumber",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/provider/:providerId/version/:versionNumber/assets",
    label: "assets",
    availability: [],
  },
  {
    pattern: "/provider/:providerId/version/:versionNumber/changelog",
    label: "changelog",
    availability: [],
  },
  {
    pattern: "/providers",
    label: "providers",
    availability: [],
  },
  {
    pattern: "/resources",
    label: "resources",
    availability: [],
  },
  {
    pattern: "/resources/configuration-management",
    label: "config management",
    availability: ["configurationManagementEnabled"],
    availabilityExpression: "configurationManagementEnabled",
  },
  {
    pattern: "/resources/iac-management",
    label: "resources iac management",
    availability: [],
  },
  {
    pattern: "/resources/iac-management/resource/:resourceId",
    label: "iac management resource details",
    availability: [],
  },
  {
    pattern: "/resources/scans",
    label: "scans layout",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId",
    label: "scan detail layout",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId/resources",
    label: "scan resources",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId/scan-runs",
    label: "scan runs",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId/scan-runs/:runId",
    label: "scan run layout",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId/scan-runs/:runId/resources",
    label: "scan resources",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId/settings",
    label: "settings",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId/settings/cloud-provider",
    label: "scan settings cloud provider",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId/settings/resource-scope",
    label: "scan settings resource scope",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/resources/scans/:scanId/settings/worker-pool",
    label: "scan settings worker pool",
    availability: ["unmanagedResourcesUi"],
    availabilityExpression: "unmanagedResourcesUi",
  },
  {
    pattern: "/runs",
    label: "runs",
    availability: [],
  },
  {
    pattern: "/settings",
    label: "settings context provider",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/api-key/:apiKeyId",
    label: "api key",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/api-key/:apiKeyId/group-mapping",
    label: "api key group mapping",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/idp-group/:idpGroupId",
    label: "idp group",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/idp-group/:idpGroupId/users",
    label: "idp group users",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/integrations/manage-slack-access",
    label: "navigate",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/role/:roleId",
    label: "role",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/role/:roleId/permissions",
    label: "settings role edit permissions",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/role/:roleId/used-by",
    label: "role used by",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/user/:userId",
    label: "user",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/user/:userId/idp-groups",
    label: "user idp groups",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/user/:userId/integrations",
    label: "user integrations",
    availability: ["viewer.admin"],
    availabilityExpression: "viewer.admin",
  },
  {
    pattern: "/settings/user/:userId/personal-api-keys",
    label: "user personal api keys",
    availability: ["viewer.admin", "canViewUsersPersonalApiKeys"],
    availabilityExpression: "viewer.admin && canViewUsersPersonalApiKeys",
  },
  {
    pattern: "/shared-modules",
    label: "shared modules new",
    availability: [],
  },
  {
    pattern: "/spacelift-repos",
    label: "spacelift vcs repos",
    availability: [],
  },
  {
    pattern: "/spacelift-repos/:repoId",
    label: "spacelift repos",
    availability: [],
  },
  {
    pattern: "/spacelift-repos/:repoId/commits",
    label: "spacelift vcs repo commits",
    availability: [],
  },
  {
    pattern: "/spacelift-repos/:repoId/commits/:sha",
    label: "spacelift vcs repo commit",
    availability: [],
  },
  {
    pattern: "/spacelift-repos/:repoId/edit/:fileName",
    label: "spacelift vcs repo edit file",
    availability: [],
  },
  {
    pattern: "/spacelift-repos/:repoId/new",
    label: "spacelift vcs repo create file",
    availability: [],
  },
  {
    pattern: "/spacelift-repos/:repoId/upload",
    label: "spacelift vcs repo upload files",
    availability: [],
  },
  {
    pattern: "/spacelift-repos/:repoId/used-by",
    label: "spacelift vcs repo used by",
    availability: [],
  },
  {
    pattern: "/spaces",
    label: "spaces",
    availability: [],
  },
  {
    pattern: "/spaces/:spaceId",
    label: "spaces",
    availability: [],
  },
  {
    pattern: "/spaces/:spaceId/api-keys",
    label: "api keys",
    availability: [],
  },
  {
    pattern: "/spaces/:spaceId/contexts",
    label: "space details contexts",
    availability: [],
  },
  {
    pattern: "/spaces/:spaceId/idp-groups",
    label: "idp groups",
    availability: [],
  },
  {
    pattern: "/spaces/:spaceId/policies",
    label: "space details policies",
    availability: [],
  },
  {
    pattern: "/spaces/:spaceId/users",
    label: "users",
    availability: [],
  },
  {
    pattern: "/stack/:stackId",
    label: "stack",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/configuration-management",
    label: "stack config management",
    availability: ["configurationManagementViewEnabled && isAnsibleStackVendor()"],
    availabilityExpression: "configurationManagementViewEnabled && isAnsibleStackVendor()",
  },
  {
    pattern: "/stack/:stackId/contexts",
    label: "contexts",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/dependencies",
    label: "stack dependencies",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/dependencies/graph",
    label: "stack dependencies graph",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/environment",
    label: "environment",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/hooks",
    label: "hooks",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/ignored-runs",
    label: "stack ignored runs",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/notifications",
    label: "notifications",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/outputs",
    label: "outputs",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/policies",
    label: "stack policies",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/prs",
    label: "pull requests",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/resources",
    label: "stack iac management",
    availability: ["!configurationManagementViewEnabled || !isAnsibleStackVendor()"],
    availabilityExpression: "(!configurationManagementViewEnabled || !isAnsibleStackVendor())",
  },
  {
    pattern: "/stack/:stackId/resources/resource/:resourceId",
    label: "iac management resource details",
    availability: ["!configurationManagementViewEnabled || !isAnsibleStackVendor()"],
    availabilityExpression: "(!configurationManagementViewEnabled || !isAnsibleStackVendor())",
  },
  {
    pattern: "/stack/:stackId/run/:runId",
    label: "run",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/scheduling",
    label: "stack scheduling",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings",
    label: "settings",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/behavior",
    label: "stack settings behavior",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/deletion",
    label: "stack settings deletion",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/integrations",
    label: "integrations",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/integrations/cloud",
    label: "stack settings integrations cloud",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/integrations/webhook/:webhookId",
    label: "stack settings integrations webhook",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/integrations/webhook/:webhookId/delivery/:deliveryId",
    label: "delivery",
    availability: [],
  },
  {
    pattern:
      "/stack/:stackId/settings/integrations/webhook/:webhookId/delivery/:deliveryId/request",
    label: "webhook details response",
    availability: [],
  },
  {
    pattern:
      "/stack/:stackId/settings/integrations/webhook/:webhookId/delivery/:deliveryId/response",
    label: "webhook details response",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/integrations/webhooks",
    label: "stack settings integrations webhooks",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/roles",
    label: "stack settings roles",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/source-code",
    label: "stack settings source code",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/settings/vendor",
    label: "stack settings vendor",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/state-history",
    label: "stack state history",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/tasks",
    label: "tasks",
    availability: [],
  },
  {
    pattern: "/stack/:stackId/workspaces",
    label: "stack workspaces",
    availability: [],
  },
  {
    pattern: "/stacks",
    label: "stacks new",
    availability: [],
  },
  {
    pattern: "/template/:templateId",
    label: "template",
    availability: [],
  },
  {
    pattern: "/template/:templateId/deployment/:deploymentId",
    label: "template deployment page",
    availability: [],
  },
  {
    pattern: "/template/:templateId/deployment/:deploymentId/change-history",
    label: "template deployment change history",
    availability: [],
  },
  {
    pattern: "/template/:templateId/deployment/:deploymentId/outputs",
    label: "template deployment outputs",
    availability: [],
  },
  {
    pattern: "/template/:templateId/deployments",
    label: "template deployments",
    availability: [],
  },
  {
    pattern: "/template/:templateId/version/:versionId",
    label: "version",
    availability: [],
  },
  {
    pattern: "/template/:templateId/version/:versionId/deploy",
    label: "deploy",
    availability: [],
  },
  {
    pattern: "/template/:templateId/version/:versionId/deployments",
    label: "template version deployments",
    availability: [],
  },
  {
    pattern: "/template/:templateId/version/:versionId/deployments/:deploymentId/update",
    label: "update deployment",
    availability: [],
  },
  {
    pattern: "/template/:templateId/version/:versionId/test-deploy",
    label: "test deploy",
    availability: [],
  },
  {
    pattern: "/templates",
    label: "templates",
    availability: [],
  },
  {
    pattern: "/templates-workbench",
    label: "templates workbench",
    availability: [],
  },
  {
    pattern: "/templates/template/:templateId",
    label: "template",
    availability: [],
  },
  {
    pattern: "/templates/template/:templateId/deployment/:deploymentId",
    label: "templates marketplace template deployment",
    availability: [],
  },
  {
    pattern: "/templates/template/:templateId/version/:versionId/deploy",
    label: "deploy",
    availability: [],
  },
  {
    pattern: "/vcs-agent-pool/:vcsAgentPoolId",
    label: "vcs agent pool redirect",
    availability: [],
  },
  {
    pattern: "/vcs-agent-pools",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/vcs/:repoId/commit/:sha",
    label: "spacelift vcs repo commit redirect",
    availability: [],
  },
  {
    pattern: "/vcs/integration/:provider/:id",
    label: "integration",
    availability: [],
  },
  {
    pattern: "/vcs/integrations",
    label: "integrations",
    availability: [],
  },
  {
    pattern: "/webhook/:webhookId",
    label: "webhook",
    availability: [],
  },
  {
    pattern: "/webhook/:webhookId/edit",
    label: "edit webhook",
    availability: [],
  },
  {
    pattern: "/webhooks",
    label: "navigate",
    availability: [],
  },
  {
    pattern: "/worker-pool/:workerPoolId",
    label: "worker pool",
    availability: [],
  },
  {
    pattern: "/worker-pools",
    label: "worker pools",
    availability: [],
  },
];
